/* eslint-disable no-undef */
import env from '../config/env'; 
import {global as globalIntercom} from './IntercomHandler';

export function trackEvent(eventName, eventProperties) {
  mixpanel.track(eventName, eventProperties);
}

export function initTracking() {
  if (env.isProduction()) {
    mixpanel.init(env.MIXPANEL_CONFIG.PROD_TOKEN);
  } else {
    mixpanel.init(env.MIXPANEL_CONFIG.DEV_TOKEN);
  }
}

export function updateUserDetails(user) {
  mixpanel.people.set({
    "$first_name": user.firstName,
    "$last_name": user.lastName,
    "$created": user.creationDate,
    "$email": user.email,
    "$last_login": new Date(),
    gender: user.gender,
    languageCode: user.languageCode,
    memberSince: user.memberSince,  
    nationalIdNumber: user.nationalIdNumber,
    phoneNumber: user.phoneNumber
  });
}

export function updateCustomUserProperties(userProperties) {
  mixpanel.people.set(userProperties);
}

// This should be called when the user logs in
export function identifyUser(user, jwtToken) {
  mixpanel.identify(user.id);
  globalIntercom.setProperties({
    app_id: env.isProduction() ? env.INTERCOM_CONFIG.PROD_APP_ID : env.INTERCOM_CONFIG.DEV_APP_ID,
    email: user.email,
    // THIS SHOULD BE UNIX TIMESTAMP
    // created_at: makeUnixTimestamp(user.creationDate),
    name: `${user.firstName} ${user.lastName}`,
    user_id: user.id,
    user_hash: jwtToken.userIdHash,
    hide_default_launcher: true,
    phone: user.phoneNumber,
    nationalIdNumber: user.nationalIdNumber,
    languageCode: user.languageCode,
    gender: user.gender
  });
}

export function addMemberType(memberType){
  globalIntercom.setProperties({
    memberType: memberType
  })
}

export function addContractInformationToIntercom(contractsInfo){
  globalIntercom.setProperties({
    address: contractsInfo.address,
    apartmentNumber: contractsInfo.apartmentNumber,
    contractType: contractsInfo.contractType
  });
  globalIntercom.initIntercom();
}



export const EVENTS = {
  ENTER_PHONE_CLICKED: 'ENTER_PHONE_CLICKED'
};



// WEBPACK FOOTER //
// ./src/tracking/tracking.js